<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>客户层级价格设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel mt-20">
      <el-table v-if="!isMobile()" :data="list" stripe style="width: 100%">
        <el-table-column align="center" label="级别" prop="name">
          <template slot-scope="scope">
            <div v-if="scope.row.edit">
              <el-input v-model="scope.row.name" size="small"></el-input>
            </div>
            <div v-else>{{ scope.row.name }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="备件折扣">
          <template slot-scope="scope">
            <div v-if="scope.row.edit">
              <el-input-number
                v-model="scope.row.discount"
                :precision="1"
                :step="1"
                :min="0"
                :max="9.9"
                size="small"
                class="mr-10"
              ></el-input-number>
              折
            </div>
            <div v-else>{{ scope.row.origin_discount }}折</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务折扣">
          <template slot-scope="scope">
            <div v-if="scope.row.edit">
              <el-input-number
                v-model="scope.row.discount_service"
                :precision="1"
                :step="1"
                :min="0"
                :max="9.9"
                size="small"
                class="mr-10"
              ></el-input-number>
              折
            </div>
            <div v-else>{{ scope.row.origin_discount_service }}折</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="批量订单增加折扣（原折扣基础上）"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.edit">
              <el-input-number
                v-model="scope.row.discount_batch"
                :precision="1"
                :step="0.1"
                :min="0"
                :max="9.9"
                size="small"
                class="mr-10"
              ></el-input-number>
              折
            </div>
            <div v-else>{{ scope.row.origin_discount_batch }}折</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="ml-10"
              plain
              size="mini"
              @click="handleSave(scope.$index, scope.row)"
              v-permission="Auth.dealerStageDiscountUpdate"
              v-if="scope.row.edit"
              >保存</el-button
            >
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.dealerStageDiscountUpdate"
              v-else
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-button
        type="primary"
        size="small"
        class="mt-10"
        plain
        v-permission="Auth.dealerStageDiscountUpdate"
        @click="handleAddRank"
        >添加层级</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  dealerStageDiscountList,
  updateDealerStageDiscount,
} from '@/service/getData'
import { isMobile } from '../../../util'

export default {
  data() {
    return {
      isMobile,
      list: [],
      loading: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await dealerStageDiscountList()
      this.list = res.data.list.map((item) => {
        item.origin_discount = item.discount
        item.origin_discount_service = item.discount_service
        item.origin_discount_batch = item.discount_batch
        item.edit = false
        return item
      })
      // .sort(function (a, b) {
      //   return a.stage - b.stage
      // })
    },
    handleEdit(index, item) {
      this.list[index].edit = true
    },

    handleAddRank() {
      this.list.push({
        name: '',
        discount: 0,
        discount_service: 0,
        discount_batch: 0,
        edit: true,
      })
    },

    async handleSave(index, item) {
      let res = await updateDealerStageDiscount(item)
      if (res.code == 0) {
        this.getData()
        // this.list[index].origin_discount = res.data.discount
        // this.list[index].origin_discount_service = res.data.discount_service
        // this.list[index].origin_discount_batch = res.data.discount_batch
        // this.list[index].edit = false
      }
    },
  },
}
</script>